export default class FootingConditions {
  // bolt and nut 
  footingType = 'Column'
  soilBearing = 6000 // psf
  concreteStrength = 3 // ksi
  tensileStrength = 60 // ksi
  cover = 3 // inches
  concreteDensity = 150 // lb/ft^3

  // ACI 318-19 22.2.1
  shearStrengthReductionFactor = 0.75 // phiV
  flexureStrengthReductionFactor = 0.65 // phiM
  fullyDevelopedMomentStrengthReductionFactor = 0.9 // phiMDeveloped
  
  dirty = false
  
  deserialize(json) {
    Object.assign(this, json)
    this.dirty = false
  }

  serialize() {
    const d = {}
    Object.keys(this).forEach( (key) => d[key] = this[key] )
    return d
  }

  onUpdate(detail) {
    this.footingType = detail.footingType
    this.soilBearing = detail.soilBearing
    this.concreteStrength = detail.concreteStrength
    this.tensileStrength = detail.tensileStrength
    this.concreteDensity = detail.concreteDensity
    this.cover = detail.cover

    document.dispatchEvent(new CustomEvent('footing-conditions-changed'))
  }
}